module.exports = __webpack_public_path__ + "static/media/Amlan Mukherjee Resume.14c86b9e.pdf";